module.exports = __webpack_public_path__ + "img/explanation.fbcd7404.svg";